import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = '/client';
export default {
  verifyClientIdentifiers(clientIdentifierCheckRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/identifier/verify`,
      clientIdentifierCheckRequest);
  },

  updateClientMobileNumber(updateClientMobileNumberRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(
        `${resource}/identifier/mobile/update`,
        updateClientMobileNumberRequest
    );
  },

  saveClientAccounts(loanId, clientsAccountRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(
      `${resource}/${loanId}/clientAccounts`,
      clientsAccountRequest
    );
  },

  createClientIdentifier(identifierPayload) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/identifier`, identifierPayload)
  },
}
